var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pagination.totalPages > 1
    ? _c(
        "nav",
        {
          staticClass: "pagination",
          attrs: { role: "navigation", "aria-label": "pagination" }
        },
        [
          _c("ul", { staticClass: "pagination-list" }, [
            _c("li", { staticClass: "pagination-prev" }, [
              _c(
                "button",
                {
                  staticClass: "pagination-previous",
                  attrs: {
                    disabled: _vm.pagination.pageIndex <= 1 ? "disabled" : false
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.pageIndex - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon-angle-left" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-page" }, [
              _c(
                "div",
                {
                  staticClass: "pagination-dropdown-label",
                  on: {
                    click: function($event) {
                      return _vm.togglePaginationDropdown()
                    }
                  }
                },
                [
                  _vm._v("\n                Showing\n                "),
                  _c("span", { staticClass: "pagination-dropdown-pages" }, [
                    _vm._v(
                      _vm._s(_vm.pagination.pageIndex) +
                        " of " +
                        _vm._s(_vm.endPage)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-angle-down" })
                ]
              ),
              _vm._v(" "),
              _vm.showDropdown
                ? _c("div", { staticClass: "pagination-dropdown" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.pages, function(page) {
                        return _c(
                          "li",
                          {
                            staticClass: "pagination-dropdown-item",
                            class: _vm.isCurrentPage(page) ? "active" : "",
                            attrs: { "data-page": page },
                            on: {
                              click: function($event) {
                                return _vm.changePage(page)
                              }
                            }
                          },
                          [_vm._v("Page " + _vm._s(page))]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-next" }, [
              _c(
                "button",
                {
                  staticClass: "pagination-next",
                  attrs: {
                    disabled:
                      _vm.pagination.pageIndex >= _vm.pagination.totalPages
                        ? "disabled"
                        : false
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.pageIndex + 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon-angle-right" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
                ]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }